/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apiKeysCreate } from "../../funcs/apiKeysCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1ApiKeysRequestBody$inboundSchema,
};

export const tool$apiKeysCreate: ToolDefinition<typeof args> = {
  name: "api-keys_create",
  description: `Create a new API key

Creates a new API key with specified permissions and settings`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apiKeysCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
